import axios from 'axios'
import fetch from '@/utils/fetch'
// const apiConfig = require('../../static/config.json')
const fileLoadPath =window.Glob.BASE_URL;
const apiUrl = window.Glob.BASE_URL;


//字典

export function getDictionary(data) {
    return fetch({
      url: apiUrl + '/api/Dictionary/GetDictionary?id='+data,
      method: 'post',
    })
  }
//   export function apiGetDictionaryWithItems(data) {
//     return fetch({
//       url: apiUrl + '/api/Dictionary/GetDictionaryWithItems?id='+data,
//       method: 'post',
//     })
//   }
  
  export function getDictionaryWithItemsBundle(data) {
    return fetch({
      url: apiUrl + '/api/Dictionary/GetDictionaryWithItemsBundle',
      method: 'post',
      data
    })
  }
  
  export function createDictionary(data) {
    return fetch({
      url: apiUrl + '/api/Dictionary/CreateDictionary',
      method: 'post',
      data
    })
  }
  
  
  export function updateDictionary(data) {
    return fetch({
      url: apiUrl + '/api/Dictionary/UpdateDictionary',
      method: 'post',
      data
    })
  }
  export function removeDictionary(data) {
    return fetch({
      url: apiUrl + '/api/Dictionary/RemoveDictionary?id='+data,
      method: 'post',
    })
  }
  
  export function getDictionaryList(data) {
    return fetch({
      url: apiUrl + '/api/Dictionary/GetDictionaryList',
      method: 'post',
      data
    })
  }
  
  export function getDictionaryItem(data) {
    return fetch({
      url: apiUrl + '/api/Dictionary/GetDictionaryItem?id='+data,
      method: 'post',
    })
  }
  
  export function createDictionaryItem(data) {
    return fetch({
      url: apiUrl + '/api/Dictionary/CreateDictionaryItem',
      method: 'post',
      data
    })
  }
  
  export function updateDictionaryItem(data) {
    return fetch({
      url: apiUrl + '/api/Dictionary/UpdateDictionaryItem',
      method: 'post',
      data
    })
  }
  export function removeDictionaryItem(data) {
    return fetch({
      url: apiUrl + '/api/Dictionary/RemoveDictionaryItem?id='+data,
      method: 'post',
    })
  }
  
  export function getDictionaryItemList(data) {
    return fetch({
      url: apiUrl + '/api/Dictionary/GetDictionaryItemList',
      method: 'post',
      data
    })
  }
  


// WEBPACK FOOTER //
// ./src/api/dictionaryApi.js